import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { DmBtnPrimary } from '../../dm/DmFormPrimitives';

interface SuccessStepProps {
    patientName: string;
    poNumber: string;
    recipients: string[];
    onBack: () => void;
}

function SuccessStep({ patientName, poNumber, recipients, onBack }: SuccessStepProps) {
    return (
        <div className="w-full max-w-xl mx-auto">
            <div className="flex items-start gap-3 p-4 rounded-xl border border-green-200 bg-green-50">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                <div className="text-sm text-green-800">
                    <div className="font-semibold mb-1">OrthoPulse order sent.</div>
                    <p>
                        PO <span className="font-mono">{poNumber}</span> for{' '}
                        <span className="font-medium">{patientName}</span> sent to{' '}
                        {recipients.join(', ')}.
                    </p>
                </div>
            </div>
            <div className="mt-6 flex justify-end">
                <DmBtnPrimary onClick={onBack}>Back to actions</DmBtnPrimary>
            </div>
        </div>
    );
}

export { SuccessStep };
